import Image from 'next/image';
import type { ReactElement } from 'react';

import styles from '@/styles/latest-news.module.css';

import { replaceSpecialCharacters } from '@/utils/replace-special-characters';

interface NewsCardsProps {
  data: {
    imglink: string;
    categories: string[];
    description: string;
    date: string;
    link: string;
    title: string;
    isoDate: string;
    imgpriority?: boolean;
    imgquality?: number;
    renderImg?: boolean;
  };
}

export default function NewsCard(props: NewsCardsProps): ReactElement {
  const { data } = props;

  function resolveColor(tagLabel: string) {
    tagLabel = tagLabel.toLowerCase();
    if (tagLabel.includes(`empregos`)) {
      return `tag-red`;
    } else if (tagLabel.includes(`empreender`)) {
      return `tag-pink`;
    } else if (tagLabel.includes(`negócios`)) {
      return `tag-blue`;
    } else {
      return `tag-green`;
    }
  }

  function resolveLinks(category: string) {
    const normalized = replaceSpecialCharacters(category).toLowerCase();
    return `https://noticias.oamarelinho.com.br/${normalized}`;
  }

  return (
    <div className={styles.noticia_item}>
      <div className={styles.noticia_item_image}>
        <a href={data.link} target="_blank" rel="noreferrer" style={{ position: 'relative' }} aria-label={data.title}>
          {data.renderImg ? (
            <Image
              src={data.imglink}
              alt={data.title}
              priority={data.imgpriority}
              quality={data.imgquality}
              width={376}
              height={251}
              sizes="376px"
            />
          ) : null}
        </a>
      </div>
      <div className={styles.noticia_item_text}>
        <ul className={styles.tag_list}>
          {data.categories.map((category, index) => (
            <li key={index} className={styles.tag_item}>
              <a href={resolveLinks(category)} target="_blank" rel="noreferrer" className={resolveColor(category)}>
                {category}
              </a>
            </li>
          ))}
        </ul>
        <a href={data.link} target="_blank" rel="noreferrer">
          <h3>{data.title}</h3>
        </a>
        <p className={styles.noticia_item_description}>{data.description}</p>
        <br />
        <br />
        <p>
          {new Date(data.isoDate).toLocaleDateString(`pt-br`, {
            year: `numeric`,
            month: `long`,
            day: `numeric`,
          })}
        </p>
      </div>
    </div>
  );
}
